module.exports = __webpack_public_path__ + "img/logo.fceac661.png";